export default "__VITE_ASSET__Gl1by8V7__"